import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Dimmer, Loader } from "semantic-ui-react";
import { getPartyIdFromStorage } from "../../storage/storage";
import { handleRouteError } from "../Util/utilActionCreators";
import { getAndGoToParty, getParty } from "./VotifyParty/partyActionCreators";
import { getPartyIdFromUrl } from "../../utils/utils";
import NoPartyScreen from "./NoPartyScreen";

class VotifyWrapper extends Component {
  componentDidMount() {
    console.log("this.componentDidMount");
    console.log("this.props");
    console.log(this.props);
    try {
      let partyId = getPartyIdFromUrl(this.props.location.pathname);
      console.log(`Extracted partyId: ${partyId}`);
      if (!partyId) {
        partyId = getPartyIdFromStorage();
      }
      console.log(`Using partyId: ${partyId}`);
      if (!this.props.hasFoundParty || this.props.partyId !== partyId) {
        this.props.getParty(partyId);
      }
    } catch (error) {
      console.log(error);
      this.props.handleRouteError();
    }
  }

  componentDidUpdate(prevProps) {
    try {
      let partyId = getPartyIdFromUrl(this.props.location.pathname);
      if (
        !this.props.hasFoundParty &&
        getPartyIdFromUrl(prevProps.location.pathname) !== partyId
      ) {
        console.log("going to party");
        this.props.getParty(partyId);
      }
    } catch (error) {
      console.log(error);
      this.props.handleRouteError();
    }
  }

  render() {
    const shouldRenderParty =
      this.props.isLookingForParty && this.props.hasFoundParty;

    if (shouldRenderParty) {
      return this.props.children;
    } else if (this.props.isLoadingParty) {
      return (
        <Dimmer active>
          <Loader size="massive" />
        </Dimmer>
      );
    } else {
      return <NoPartyScreen />;
    }
  }
}

VotifyWrapper.propTypes = {
  getAndGoToParty: PropTypes.func.isRequired,
  handleRouteError: PropTypes.func.isRequired,

  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,

  partyId: PropTypes.string,
  partyUrl: PropTypes.string,
  isLookingForParty: PropTypes.bool,
  hasAckParty: PropTypes.bool,
  hasFoundParty: PropTypes.bool,
  isLoadingParty: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    partyId: state.party.partyId,
    partyUrl: state.party.partyUrl,
    isLookingForParty: state.party.isLookingForParty,
    hasAckParty: state.party.hasAckParty,
    hasFoundParty: state.party.hasFoundParty,
    isLoadingParty: state.party.isLoadingParty,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  console.log(ownProps);
  return {
    getAndGoToParty: (partyId) =>
      dispatch(getAndGoToParty(partyId, ownProps.history)),
    handleRouteError: () => dispatch(handleRouteError(ownProps.history)),
    getParty: (partyId) => dispatch(getParty(partyId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VotifyWrapper);
